import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';

import { Form, Col, Row, InputGroup } from 'react-bootstrap-5';

export default function ForwardingEmail({ database }) {
  const inputRef = useRef(null);

  const copy = (e) => {
    e.preventDefault();

    inputRef.current.select();

    navigator.clipboard.writeText(database.forwardingEmail);
  };

  return (
    <Row>
      <Col className="d-flex align-items-center" lg={6} xs={12}>
        <InputGroup>
          <InputGroup.Text>
            <FontAwesomeIcon className="icon" icon={faEnvelope} size="lg" />
          </InputGroup.Text>
          <Form.Control readOnly ref={inputRef} type="text" value={database.forwardingEmail}/>
        </InputGroup>

        <a className="mx-4 clickable" onClick={copy}> Copy </a>
      </Col>
    </Row>
  );
}

ForwardingEmail.propTypes = {
  database: PropTypes.shape({
    forwardingEmail: PropTypes.string,
    name: PropTypes.string
  }).isRequired
};
